import 'focus-visible';

// Polyfill sendBeacon if it doesn't exist. From https://github.com/miguelmota/Navigator.sendBeacon
const isBeaconSupported = (('navigator' in window)
    && ('sendBeacon' in window.navigator));

if (!isBeaconSupported) {
    const sendBeacon = function(url, data) {
        const xhr = ('XMLHttpRequest' in window) ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP'); // eslint-disable-line no-undef
        xhr.open('POST', url, false);
        xhr.withCredentials = true;
        xhr.setRequestHeader('Accept', '*/*');
        if (typeof data === 'string') {
            xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
            xhr.responseType = 'text/plain';
        }
        else if (({}).toString.call(data) === '[object Blob]') {
            if (data.type) {
                xhr.setRequestHeader('Content-Type', data.type);
            }
        }

        try {
            xhr.send(data);
        }
        catch (error) {
            return false;
        }
        return true;
    };

    window.navigator.sendBeacon = sendBeacon;
}
